import React, { useState } from "react";
import { LeadViewEditViewPrimaryInfoProps } from "./lead-view-edit-view-primary-info.props";
import { Box } from "@mui/material";
import { Formik, Form } from "formik";
import profileIcon from "../../../../../../assets/icons/profile.svg";
import {
  LEAD_SOURCE_OPTIONS,
} from "../../../../../../constants/leadDropdown";
import leadInfoIcon from "../../../../../../assets/icons/leadInfo.svg";
import {
  TextInputComponent,
  PhoneNumberComponent,
  SelectInputComponent,
  UploadImage,
} from "../../../../../../common/components";
import "./lead-view-edit-view-primary-info.scss";
import { useLeadOwnerOptions } from "../../../../../../utils/getLeadOwnerOptions";

const LeadViewEditViewPrimaryInfo: React.FC<
  LeadViewEditViewPrimaryInfoProps
> = (props: any) => {
  const { allLeadData, viewPrimaryInfoOpen, setViewPrimaryInfoOpen } = props;
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const initialValues = {
    title: "",
    company: "",
    firstName: "",
    lastName: "",
    email: "",
    secondaryEmail: "",
    fax: "",
    website: "",
    numEmployees: "",
    annualRevenue: "",
    interestedProduct: "",
    socialLeadId: "",
    streetAddress: "",
    description: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    workPhone: {
      primaryPhoneNumber: "",
      primaryCountryCode: "+1",
      secondaryPhoneNumber: "",
      secondaryCountryCode: "+1",
    },
    imageUrl: "",
  };
  const LEAD_OWNER_OPTIONS = useLeadOwnerOptions();
  const [selectedInterestedProduct, setInterestedProduct] = useState([]);
  const [selectedLeadOwner, setSelectedLeadOwner] = useState("");
  const [selectedLeadSource, setSelectedLeadSource] = useState("Manual");
  const [selectedLeadStatus, setSelectedLeadStatus] = useState("New Lead");
  const [selectedRating, setSelectedRating] = useState("");
  const [selectedIndustry, setSelectedIndustry] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleCancel = async (values: any) =>
    setViewPrimaryInfoOpen(!viewPrimaryInfoOpen);
  const handleSave = async (values: any) => {
    try {
      const payload = {
        company: values.company,
        title: values.title,
        firstName: values.firstName,
        lastName: values.lastName,
        primaryEmail: values.email,
        secondaryEmail: values.secondaryEmail || null,
        primaryPhoneNumber:
          values.workPhone?.primaryCountryCode &&
          values.workPhone?.primaryPhoneNumber
            ? `${values.workPhone.primaryCountryCode}-${values.workPhone.primaryPhoneNumber}`
            : null,
        secondaryPhoneNumber:
          values.workPhone?.secondaryCountryCode &&
          values.workPhone?.secondaryPhoneNumber
            ? `${values.workPhone.secondaryCountryCode}-${values.workPhone.secondaryPhoneNumber}`
            : null,
        website: values.website || null,
        address: {
          street: values.streetAddress || null,
          city: values.city || null,
          state: values.state || null,
          country: values.country || null,
          zipcode: values.zipcode || null,
        },
        leadSource: selectedLeadSource || null,
        leadStatus: selectedLeadStatus || null,
        imageUrl: values.imageUrl || null,
        faxNumber: values.fax || null,
        industry: selectedIndustry || null,
        numberOfEmployees: values.numEmployees || null,
        annualRevenue: values.annualRevenue || null,
        interestedProducts:
          Array.isArray(selectedInterestedProduct) &&
          selectedInterestedProduct.length > 0
            ? selectedInterestedProduct.join(", ")
            : null,
        rating: selectedIndustry || null,
        socialLeadId: values.socialLeadId || null,
        description: values.description || null,
      };
      //   const response = await leadCreate(payload);
      //   if (response.data.success) {
      //     setAlertMessage("Lead saved successfully!");
      //     setAlertType("success");
      //     setAlertOpen(true);
      //     setTimeout(() => {
      //       navigate(routes.LEADLIST);
      //     }, 3000);
      //   } else {
      //     setAlertMessage("Failed to save lead.");
      //     setAlertType("error");
      //     setAlertOpen(true);
      //   }
    } catch (error) {
      // setAlertMessage("An error occurred while saving the lead.");
      // setAlertType("error");
      // setAlertOpen(true);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        handleSave(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <div className="lead-list-view-details-view-box-primary-info">
            <div className="lead-list-view-details-view-box-primary-info-profile">
              <div className="lead-list-view-details-view-box-primary-info-profile-pic">
                <UploadImage
                  label="Upload Photo"
                  text="logo"
                  value={values?.imageUrl}
                  onChange={(file: any) => {
                    setFieldValue("imageUrl", file);
                  }}
                />
              </div>
              <div className="lead-list-view-details-view-box-primary-info-profile-details">
                <div className="lead-list-view-details-view-box-primary-info-profile-details-name">
                  John Doe
                </div>
                <div className="lead-list-view-details-view-box-primary-info-profile-details-contact">
                  <span>
                    <i className="fa fa-phone" style={{ color: "#B4B4B4" }}></i>
                    &nbsp; +1-(545)677-6545
                  </span>
                  &nbsp;&nbsp;
                  <span style={{ borderLeft: "1px solid #B4B4B4" }}>
                    &nbsp;&nbsp;
                    <i
                      className="fa fa-envelope"
                      style={{ color: "#B4B4B4" }}
                    ></i>
                    &nbsp; john@gmail.com
                  </span>
                </div>
              </div>
            </div>

            <div className="lead-list-view-details-view-box-primary-info-other">
              <div className="lead-list-view-details-view-box-primary-info-other-section">
                <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                  Lead Owner
                </div>
                <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                  <SelectInputComponent
                    fieldName="leadOwner"
                    options={LEAD_OWNER_OPTIONS}
                    onChange={setSelectedLeadOwner}
                    value={selectedLeadOwner}
                    placeholder="Enter lead owner"
                  />
                </div>
              </div>
              <div className="lead-list-view-details-view-box-primary-info-other-section">
                <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                  Lead Source
                </div>
                <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                  <SelectInputComponent
                    fieldName="leadSource"
                    options={LEAD_SOURCE_OPTIONS}
                    onChange={setSelectedLeadSource}
                    value={selectedLeadSource || "None"} // This will bind the selected value
                  />
                </div>
              </div>
              <div className="lead-list-view-details-view-box-primary-info-other-section">
                <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                  Assigned Partner
                </div>
                <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                  <TextInputComponent
                    type="text"
                    fieldName="title"
                    placeholder="Enter title"
                    optional={false}
                    disabled={false}
                    value={values.title}
                    onChange={(e: any) =>
                      setFieldValue("title", e?.target?.value)
                    }
                  />
                </div>
              </div>
              <div className="lead-list-view-details-view-box-primary-info-other-section">
                <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                  Phone
                </div>
                <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                  <PhoneNumberComponent
                    fieldName="workPhone.secondaryPhoneNumber"
                    countryCodeFieldName="workPhone.secondaryCountryCode"
                    placeholder="Enter Phone Number"
                    optional={false}
                  />
                </div>
              </div>
              <div className="lead-list-view-details-view-box-primary-info-other-section">
                <div className="lead-list-view-details-view-box-primary-info-other-section-main-text">
                  Lead Status
                </div>
                <div className="lead-list-view-details-view-box-primary-info-other-section-sub-text">
                  In Progress
                </div>
              </div>
            </div>
          </div>
          <Box className="footer">
            <button
              type="button"
              className="cancel-button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button type="submit" className="cancel-button next-button-wrapper">
              Save
            </button>
          </Box>
        </Form>
      )}
    </Formik>
  );
};

export default LeadViewEditViewPrimaryInfo;
